import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-user-icon',
  templateUrl: './general-user.component.html'
})
export class GeneralUserComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
